package team.platforma.dictionary_data.di

import org.koin.core.module.Module
import org.koin.dsl.bind
import org.koin.dsl.module
import team.platforma.dictionary_data.database.ai_chapter.AiChapterTable
import team.platforma.dictionary_data.database.ai_chapter.AiChapterTableImpl
import team.platforma.dictionary_data.database.ai_model.AiModelTable
import team.platforma.dictionary_data.database.ai_model.AiModelTableImpl
import team.platforma.dictionary_data.repository.AiChapterRepository
import team.platforma.dictionary_data.repository.AiChapterRepositoryImpl
import team.platforma.dictionary_data.repository.ai_model.AiModelRepository
import team.platforma.dictionary_data.repository.ai_model.AiModelRepositoryImpl

val dictionaryDataModule: Module = module {
    single {
        AiChapterTableImpl(dictionaryDatabase = get())
    }.bind<AiChapterTable>()
    single {
        AiChapterRepositoryImpl(
            aiChapterTable = get()
        )
    }.bind<AiChapterRepository>()

    single {
        AiModelTableImpl(dictionaryDatabase = get())
    }.bind<AiModelTable>()
    single {
        AiModelRepositoryImpl(
            client = get(),
            aiModelTable = get(),
            aiChapterTable = get()
        )
    }.bind<AiModelRepository>()

}